import { browser } from '$app/environment';

export class ScrollSpy {
  private elements = [] as HTMLElement[];
  private observer?: IntersectionObserver;

	constructor(on_intersection: (id: string | null) => void) {
		if (browser) this.observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) on_intersection(entry.target.id);
				})
			}, {
				rootMargin: '-60px 0px -85% 0px',
				threshold: [0]
			}
		);
  }

	addItem(element: HTMLElement) {
		this.elements.push(element);
		this.observer?.observe(element);
	}

  scrollTo(id: string | null) {
		if (!id) return;
    this.elements.find((el) => el.id === id)?.scrollIntoView({ behavior: 'smooth' });
  }

	destroy() {
		this.observer?.disconnect();
	}
}
